/**
 * Decode HTML entities (e.g. &amp; → &, &amp;amp; → &)
 * Handles multiple levels of encoding.
 */
const decodeHtml = (html) => {
    if (!html) return '';
    const txt = document.createElement('textarea');
    // Decode potentially double/triple encoded entities
    let decoded = html;
    let prev = '';
    // Keep decoding until stable (handles &amp;amp;amp; chains)
    while (decoded !== prev) {
        prev = decoded;
        txt.innerHTML = decoded;
        decoded = txt.value;
    }
    // Clean redundant shift markers if (Morning&Afternoon) exists
    if (typeof decoded === 'string' && decoded.includes('(Morning&Afternoon)')) {
        decoded = decoded.replace(/\s*\(Morning\)\s*$/i, '');
        decoded = decoded.replace(/\s*\(Afternoon\)\s*$/i, '');
    }

    return decoded;
};

export { decodeHtml };
export default decodeHtml;
